


























import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store);
